import script from "./Popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Popup.vue?vue&type=script&setup=true&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=39abf8ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39abf8ea"]])

export default __exports__